import React from "react";

const MicroCombo = ({
	classNames,
	theme = "light",
	alignment,
	width = "100%",
}) => {
	// Create a reference to the <div> element which will represent the TrustBox
	const microRef = React.useRef(null);
	React.useEffect(() => {
		// If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
		// If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
		// When it is, it will automatically load the TrustBox.
		if (window.Trustpilot) {
			window.Trustpilot.loadFromElement(microRef.current, true);
		}
	}, []);
	return (
		<div
			ref={microRef}
			className={`trustpilot-widget ${classNames || ""}`}
			data-locale="en-GB"
			data-template-id="5419b6ffb0d04a076446a9af"
			data-businessunit-id="5c5455fdfdd26f0001066878"
			data-style-height="20px"
			data-style-width={width}
			data-token="d26dff96-3178-4c2b-917c-a2c4e442c197"
			data-theme={theme}
			data-style-alignment={alignment}
		>
			<a
				href="https://uk.trustpilot.com/review/edyn.care"
				target="_blank"
				rel="noopener"
			>
				Trustpilot
			</a>
		</div>
	);
};

const MicroReviewCount = ({ classNames }) => {
	const microReviewCountRef = React.useRef(null);

	React.useEffect(() => {
		if (window.Trustpilot) {
			window.Trustpilot.loadFromElement(microReviewCountRef.current, true);
		}
	}, []);

	return (
		<div
			ref={microReviewCountRef}
			className={`trustpilot-widget ${classNames || ""}`}
			data-locale="en-GB"
			data-template-id="5419b6a8b0d04a076446a9ad"
			data-businessunit-id="5c5455fdfdd26f0001066878"
			data-style-height="24px"
			data-style-width="100%"
			data-token="a0c84b59-fc22-4bdc-a5bd-bc96f580b86a"
			data-min-review-count="0"
			data-style-alignment="center"
		>
			<a
				href="https://uk.trustpilot.com/review/edyn.care"
				target="_blank"
				rel="noopener"
			>
				Trustpilot
			</a>
		</div>
	);
};

const MicroStar = ({ classNames }) => {
	const microStarRef = React.useRef(null);

	React.useEffect(() => {
		if (window.Trustpilot) {
			window.Trustpilot.loadFromElement(microStarRef.current, true);
		}
	}, []);

	return (
		<div
			ref={microStarRef}
			className={`trustpilot-widget ${classNames || ""}`}
			data-locale="en-GB"
			data-template-id="5419b732fbfb950b10de65e5"
			data-businessunit-id="5c5455fdfdd26f0001066878"
			data-style-height="24px"
			data-style-width="100%"
			data-token="4f16e51c-aba0-4525-9a52-7121973ee8df"
		>
			<a
				href="https://uk.trustpilot.com/review/edyn.care"
				target="_blank"
				rel="noopener"
			>
				Trustpilot
			</a>
		</div>
	);
};

const MicroTrustScore = ({ classNames }) => {
	const microTrustScoreRef = React.useRef(null);

	React.useEffect(() => {
		if (window.Trustpilot) {
			window.Trustpilot.loadFromElement(microTrustScoreRef.current, true);
		}
	}, []);

	return (
		<div
			ref={microTrustScoreRef}
			className={`trustpilot-widget ${classNames || ""}`}
			data-locale="en-GB"
			data-template-id="5419b637fa0340045cd0c936"
			data-businessunit-id="5c5455fdfdd26f0001066878"
			data-style-height="20px"
			data-style-width="100%"
			data-token="0655eadb-150b-4762-9525-b53a73d81b35"
		>
			<a
				href="https://uk.trustpilot.com/review/edyn.care"
				target="_blank"
				rel="noopener"
			>
				Trustpilot
			</a>
		</div>
	);
};

const MiniScore = ({ width = "100%", classNames }) => {
	// Create a reference to the <div> element which will represent the TrustBox
	const miniRef = React.useRef(null);
	React.useEffect(() => {
		// If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
		// If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
		// When it is, it will automatically load the TrustBox.
		if (window.Trustpilot) {
			window.Trustpilot.loadFromElement(miniRef.current, true);
		}
	}, []);
	return (
		<div
			ref={miniRef}
			className={`trustpilot-widget ${classNames || ""}`}
			data-locale="en-GB"
			data-template-id="53aa8807dec7e10d38f59f32"
			data-businessunit-id="5c5455fdfdd26f0001066878"
			data-style-height="150px"
			data-style-width={width}
			data-theme="dark"
		>
			<a
				href="https://uk.trustpilot.com/review/edyn.care"
				target="_blank"
				rel="noopener"
			>
				Trustpilot
			</a>
		</div>
	);
};

export {
	MicroCombo,
	MicroReviewCount,
	MicroStar,
	MicroTrustScore,
	MiniScore,
};
